import Vue from 'vue'
import { baseState } from './state'

// Might want to change it to UUID
const indexBy = 'id'

const mutations = {
  SET (state, request = []) {
    state.users = {}
    request.data.forEach(user => {
      Vue.set(state.users, user[indexBy], user)
    })
    state.currentPage = parseInt(request.headers['x-pagination-current-page'])
    state.totalPageCount = parseInt(request.headers['x-pagination-page-count'])
  },

  SET_PER_PAGE (state, perPage) {
    state.perPage = perPage
  },

  ADD (state, user) {
    user.password = ''
    Vue.set(state.users, user[indexBy], user)
  },

  SET_NEW (state, userId) {
    state.newUser = state.users[userId]
  },

  CLEAR_NEW (state) {
    let cleanUser = baseState().newUser
    Object.keys(cleanUser).forEach(key => {
      state.newUser[key] = cleanUser[key]
    })
    state.assignedRoles = []
    state.selectedRoles = []
    state.assignedSites = []
    state.selectedSites = []
  },

  SET_ROLES (state, roles) {
    Vue.set(state, 'selectedRoles', roles)
  },

  SET_ASSIGNED_ROLES (state, roles) {
    Vue.set(state, 'assignedRoles', roles.slice())
  },

  SET_SITES (state, sites) {
    Vue.set(state, 'selectedSites', sites)
  },

  SET_ASSIGNED_SITES (state, sites) {
    Vue.set(state, 'assignedSites', sites.slice())
  }
}

export default mutations
